var els = $('nav.panel-nav[data-internal-nav]');
if (els.length > 0) {
  require.ensure('../modules/panel_tabs', function(require) {
    var PanelTabs = require('../modules/panel_tabs');
    els.each(function() {
      return new PanelTabs(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/panel_tabs.initializer.js